"use strict";
/* tslint:disable */
var TEditOpenBetSPSlipMode = (function () {
    "use strict";
    var api = {};
    // Overrides ComboSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };
    // Template logic splitter
    api.buildOptions = function (selections) {
        /*globals Modes */
        Modes.calcComboVariants(this);
        return "";
    };
    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        Modes.calcComboVariants(this);
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };
    api.buildHeader = function () {
        return TSlipShared.createEditModeHeader($dict.bs("EditOpenBetSPSlipHeader"), this.ComboNames[this.Variants.length - 1]);
    };
    return api;
}());
window.TEditOpenBetSPSlipMode = TEditOpenBetSPSlipMode;
//# sourceMappingURL=TEditOpenBetSPSlipMode.js.map